import * as React from "react";
import PropTypes from 'prop-types';

const SvgSflError = props => {
  if (props.id !== "_svgsflerror") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 48 48" {...props}><g fill="none" fillRule="evenodd"><path d="M0 0h48v48H0z" /><path fill="#A2000F" d="M36.232 17.75l-6.122-6.01c-.469-.467-1.075-.74-1.738-.74l-8.775.015a2.39 2.39 0 00-1.678.694l-5.984 5.871A3.168 3.168 0 0011 19.836v8.36c0 .692.27 1.343.76 1.833l6.052 6.045a2.72 2.72 0 001.935.8h8.49c.739 0 1.434-.288 1.955-.81l5.844-5.834c.62-.62.961-1.442.961-2.319v-8.316c0-.697-.272-1.352-.765-1.845zm-12.926-.278a.747.747 0 011.493 0v9.924a.747.747 0 01-1.493 0v-9.924zm.747 13.808a.971.971 0 11-.002-1.943.971.971 0 01.002 1.943z" /></g></svg>;
};

SvgSflError.displayName = "_svgsflerror";
SvgSflError.propTypes = {
  id: PropTypes.string
};
SvgSflError.defaultProps = {
  id: ''
};
export default SvgSflError;